import { render } from "./Aplication.vue?vue&type=template&id=238b18af"
import script from "./Aplication.vue?vue&type=script&lang=js"
export * from "./Aplication.vue?vue&type=script&lang=js"

import "./Aplication.vue?vue&type=style&index=0&id=238b18af&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__